export interface ApiConfig {
    API_URL: string;
    AUTH_URL: string;
}

const win: ApiConfig = {
    // API_URL: 'https://stage-ecopetrol-api.ig-eng.org/api',
    // AUTH_URL: 'https://stage-ecopetrol-api.ig-eng.org/api/auth'
    // API_URL: 'http://192.168.88.240:5245/api',
    // AUTH_URL: 'http://192.168.88.240:5245/api/auth'
    // API_URL: 'http://192.168.137.1:5245/api',
    // AUTH_URL: 'http://192.168.137.1:5245/api/auth'
    API_URL: 'http://localhost:5245/api',
    AUTH_URL: 'http://localhost:5245/api/auth'
};

const mac: ApiConfig = {
    API_URL: 'http://localhost:5245/api',
    AUTH_URL: 'http://localhost:5245/api/auth'
    // API_URL: 'http://192.168.88.74:5245/api',
    // AUTH_URL: 'http://192.168.88.74:5245/api/auth'
};

const production: ApiConfig = {
    API_URL: 'https://ecopetrol-api.inerps.eu/api',
    AUTH_URL: 'https://ecopetrol-api.inerps.eu/api/auth'
};


const stage: ApiConfig = {
    API_URL: 'https://stage-ecopetrol-api.inerps.eu/api',
    AUTH_URL: 'https://stage-ecopetrol-api.inerps.eu/api/auth'
}
const environments = {
    win,
    mac,
    production,
    stage
}

// export const env = process.env.REACT_APP_STAGE === `production` ? prod : dev;
// export const env = environments[process.env.REACT_APP_STAGE];
//@ts-ignore
export const apiConfig: ApiConfig = environments[process.env.REACT_APP_STAGE];
